import { useCallback, useState } from "react"

export const useDrag = onDrag => {
  const [dragging, setDragging] = useState(false)
  const [lastMousePosition, setLastMousePosition] = useState({ x: 0, y: 0 })

  const handleMouseDown = useCallback(event => {
    setLastMousePosition({ x: event.clientX, y: event.clientY })
    setDragging(true)
  }, [])

  const handleMouseUp = useCallback(() => {
    setDragging(false)
  }, [])

  const handleMouseMove = useCallback(
    event => {
      if (dragging) {
        const newPosition = { x: event.clientX, y: event.clientY }
        onDrag(lastMousePosition, newPosition)
        setLastMousePosition(newPosition)
      }
    },
    [dragging, lastMousePosition, onDrag],
  )

  return { handleMouseDown, handleMouseUp, handleMouseMove }
}
